import { Range } from 'sonata-react-components';

type Props = {
  budget: number;
  className: string;
  id: string;
  leftLabel: string;
  onChange: (value: number) => void;
  rightLabel: string;
  title: string;
  value: number;
};

export function DistributionSlider({ budget, className, id, leftLabel, onChange, rightLabel, title, value }: Props) {
  return (
    <Range
      className={className}
      id={id}
      max={budget}
      min={0}
      onChange={newValue => onChange(Math.round(((newValue as number) / budget) * 100))}
      type="slider"
      value={Math.round((value / 100) * budget)}
    >
      <Range.Box title={title}>
        <Range.Title>
          <Range.Title.Left>{leftLabel}</Range.Title.Left>
          <Range.Title.Right>{rightLabel}</Range.Title.Right>
        </Range.Title>
        <Range.SliderInput />
      </Range.Box>
    </Range>
  );
}
